/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { FormattedMessage } from 'react-intl';
import styles from './multiselect.module.scss';
import Clickable from '../../../components/clickable/Clickable';

class Multiselect extends Component {
  constructor(props) {
    super(props);
    const { isRequired, updateFieldErrors, answer, default_value, fieldId } = this.props;
    if (default_value?.key && (answer === '' || answer === undefined || answer === null || answer?.length === 0)) {
      this.handleAnswerChanged(default_value?.key, fieldId);
    } else if (isRequired && ((Array.isArray(answer) && answer.length === 0) || answer === undefined)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, values, updateFieldErrors, answer, dataSourceID
    } = this.props;
    let newAnswer;
    let updatedErrors = [];
    if (dataSourceID === 'ds9') {
      handleValueChange(value, fieldId);

      if ((Array.isArray(value) && value.length === 0) || !value) {
        handleFieldErrorChanged(fieldId, isRequired);
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.not_blank'
        ];
      } else {
        const validOption = Object.keys(
          values
        ).some(
          k => (value.includes(values[k].key))
        );

        handleFieldErrorChanged(fieldId, !validOption);
        if (!validOption) {
          updatedErrors = [
            ...updatedErrors,
            'pulpoforms.errors.select.invalid_option'
          ];
        }
      }
    } else {
      if ((answer || []).map(e => e).includes(value)) {
        newAnswer = answer.filter(e => e !== value);
      } else {
        newAnswer = [...(answer || []), value];
      }
      handleValueChange(newAnswer, fieldId);

      if ((Array.isArray(newAnswer) && newAnswer.length === 0) || value === undefined) {
        handleFieldErrorChanged(fieldId, isRequired);
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.not_blank'
        ];
      } else {
        const validOption = Object.keys(
          values
        ).some(
          k => (values[k].key === value)
        );

        handleFieldErrorChanged(fieldId, !validOption);
        if (!validOption) {
          updatedErrors = [
            ...updatedErrors,
            'pulpoforms.errors.select.invalid_option'
          ];
        }
      }
    }
    updateFieldErrors(updatedErrors);
  }

  handleMultiAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, values, updateFieldErrors
    } = this.props;
    handleValueChange(value, fieldId);
    let updatedErrors = [];
    if ((Array.isArray(value) && value.length === 0) || value === undefined) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [
        ...updatedErrors,
        'pulpoforms.errors.not_blank'
      ];
    } else {
      const validOption = value.every(ele => Object.keys(
          values
        ).some(
          k => (values[k].key === ele)
        ));
      handleFieldErrorChanged(fieldId, !validOption);
      if (!validOption) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.select.invalid_option'
        ];
      }
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { fieldId, answer, values, disabled, widget, settings, fieldType, dataSourceID, fullWidth } = this.props;
    let fieldWidget;
    let selectedValue = answer;
    let dropdownValues = values;
    if (dataSourceID === 'ds9') {
      const filterColors = inputValue => dropdownValues.filter(i => i.label.toLowerCase().includes(inputValue.toLowerCase()));
      const loadOptions = (
        inputValue,
        callback
      ) => {
        setTimeout(() => {
          callback(filterColors(inputValue));
        }, 500);
      };
      fieldWidget = (
        <AsyncSelect
        value={(selectedValue || [])?.map(ele => ({ label: ele, value: ele }))}
        cacheOptions
        loadOptions={loadOptions}
        defaultOptions
        isMulti
        onChange={e => this.handleAnswerChanged(e?.map(ele => ele.value), fieldId, e)}
        openMenuOnFocus />
      );
    }
    return (
      <>
       <div style={{ display: 'flex' }}>
        {values?.length !== answer?.length && settings?.disable_Multi_selection !== false && (
          <Clickable
            className={styles.detailsLink}
            onClick={() => this.handleMultiAnswerChanged(values?.map(i => i.key) ?? [], fieldId)}
          >
            <FormattedMessage
              id="pulpofield.select.all"
              defaultMessage="Select All"
              tagName="p"
            />
          </Clickable>
        )}
        {values?.length === answer?.length && (
          <Clickable
            className={styles.detailsLink}
            onClick={() => this.handleMultiAnswerChanged([], fieldId)}
          >
            <FormattedMessage
              id="pulpofield.unselect.all"
              defaultMessage="Clear Selection"
              tagName="p"
            />
          </Clickable>
        )}
       </div>
      {fieldType === 'dataSourceMultiselect' && dataSourceID === 'ds9' ? <>{fieldWidget}</>
      : widget?.type === 'dropdown'
        ? <div style={{ width: fullWidth ? '760px' : '330px' }}>
            <Select
                isMulti
                value={values.filter(e => answer?.includes(e?.key)).map(ele => ({ key: ele?.key, label: ele?.value, value: ele?.value }))}
                onChange={e => this.handleMultiAnswerChanged(e?.map(i => i.key) ?? [], fieldId)}
                options={values.map(ele => ({ key: ele?.key, label: ele?.value, value: ele?.value }))}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 1001 })
                }}
                menuPortalTarget={document.body}
                isDisabled={disabled}
              />
          </div>
        : values.map(option => (
          <label className={styles.checkbox} key={option.key}>
            <input
              type="checkbox"
              value={option.key}
              checked={answer && answer.indexOf(option.key) >= 0}
              onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
              disabled={disabled}
            />
            {option.value}
          </label>
        ))
      }
      </>
    );
  }
}

Multiselect.defaultProps = {
  answer: []
};

Multiselect.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  answer: PropTypes.arrayOf(PropTypes.string),
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

export default Multiselect;
